export default "__VITE_ASSET__DcIzRXwD__"